import { createTheme } from '@mui/material/styles';
import { purple } from '@mui/material/colors';

const theme = createTheme({
  typography: {
    fontSize: 14,
    h1: {
      fontSize: "2rem",
      fontWeight: "bold",
      padding: "1rem",
    },
    h2: {
      fontSize: "1.5rem",
      padding: "1rem",
    },
    button: {
      textTransform: "none",
    },
    fontFamily: [
      '"Noto Sans cjk jp"',
      '"Hiragino Kaku Gothic ProN"',
      '"Hiragino Sans"',
      'Meiryo',
      'Noto Sans JP',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  palette: {
    primary: {
      main: purple[600],
    },
    // type: 'light',
  },
});

export default theme;
